<template>
  <FormHeading :h="5">{{ $tt('military_service') }}</FormHeading>
  <AppRow>
    <YesNoRadio v-model="military.served" :label="$tt('did_army')" />
    <v-scroll-x-transition>
      <AppSelect
        v-if="military.served"
        v-model="military.role"
        :label="$tt('military_service_type')"
        :items="toSelectItems(roles)"
        :rules="[required]"
      />
    </v-scroll-x-transition>
    <v-scroll-x-transition>
      <AppSelect
        v-if="military.served"
        v-model="military.rank"
        :label="$tt('military_rank')"
        :items="toSelectItems(ranks)"
        :rules="[required]"
      />
    </v-scroll-x-transition>
  </AppRow>
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { Military, MilitaryRank, MilitaryRole } from '~/types';

const { tt } = useLocalization();
const { required } = useValidation();

const military = defineModel<Military>({ required: true });

const roles: Record<MilitaryRole, string> = {
  fighter: tt('military_roles.fighter'),
  support: tt('military_roles.support'),
  office: tt('military_roles.office')
};

const ranks: Record<MilitaryRank, string> = {
  private: tt('military_ranks.private'),
  corporal: tt('military_ranks.corporal'),
  sergeant: tt('military_ranks.sergeant'),
  staff_sergeant: tt('military_ranks.staff_sergeant'),
  nco: tt('military_ranks.nco'),
  officer: tt('military_ranks.officer'),
  other: tt('other')
};
</script>